// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"997fdbbc","408":"e35d885a"}[chunkId] + ".chunk.js";
};